import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faTruck, faStore, faUserCheck } from "@fortawesome/free-solid-svg-icons";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const sellers = [
  {
    name: "Sakshi Deshmukh",
    product: "Organic Jaggery & Honey",
    pickupStatus: "Ready",
    hubStatus: "In Transit",
    haatStatus: "Pending",
    deliveryStatus: "Pending",
    sales: [50, 70, 65, 80],
  },
  {
    name: "Rekha Jadhav",
    product: "Handmade Herbal Soaps",
    pickupStatus: "Scheduled",
    hubStatus: "Pending",
    haatStatus: "Pending",
    deliveryStatus: "Pending",
    sales: [40, 60, 75, 90],
  },
  {
    name: "Anita More",
    product: "Homemade Snacks & Papad",
    pickupStatus: "Completed",
    hubStatus: "Completed",
    haatStatus: "Pending",
    deliveryStatus: "Pending",
    sales: [30, 45, 55, 70],
  },
];

export default function LogisticsFlowPlanner() {
  const [selectedSeller, setSelectedSeller] = useState(null);

  const chartData = {
    labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
    datasets: sellers.map((seller, idx) => ({
      label: seller.name,
      data: seller.sales,
      backgroundColor: `rgba(${50 + idx * 50}, 123, 255, 0.6)`,
    })),
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "bottom", labels: { color: "#fff" } },
      title: { display: true, text: "Weekly Sales Trend", color: "#fff", font: { size: 16 } },
    },
    scales: {
      x: { ticks: { color: "#fff" }, grid: { color: "#444" } },
      y: { ticks: { color: "#fff" }, grid: { color: "#444" } },
    },
  };

  return (
    <div className="min-h-screen bg-black text-white p-4">
      <h1 className="text-xl lg:text-2xl font-bold text-center mb-6 text-pink-400">
        MahilaMandi Logistics Flow Planner
      </h1>

      {/* Sellers List */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-4">
        {sellers.map((seller, idx) => (
          <div
            key={idx}
            className="bg-gray-900 rounded-xl p-4 shadow-md hover:shadow-lg transition cursor-pointer"
            onClick={() => setSelectedSeller(idx === selectedSeller ? null : idx)}
          >
            <h2 className="text-lg font-semibold mb-2">{seller.name}</h2>
            <p className="text-gray-300 mb-2">{seller.product}</p>

            {/* Flow Icons */}
            <div className="flex justify-between items-center text-pink-400">
              <div className="flex flex-col items-center">
                <FontAwesomeIcon icon={faHome} size="2x" />
                <span className="text-xs">{seller.pickupStatus}</span>
              </div>
              <div className="flex flex-col items-center">
                <FontAwesomeIcon icon={faTruck} size="2x" />
                <span className="text-xs">{seller.hubStatus}</span>
              </div>
              <div className="flex flex-col items-center">
                <FontAwesomeIcon icon={faStore} size="2x" />
                <span className="text-xs">{seller.haatStatus}</span>
              </div>
              <div className="flex flex-col items-center">
                <FontAwesomeIcon icon={faUserCheck} size="2x" />
                <span className="text-xs">{seller.deliveryStatus}</span>
              </div>
            </div>

            {/* Popup for Seller Details */}
            {selectedSeller === idx && (
              <div className="mt-4 bg-gray-800 rounded-lg p-3">
                <h3 className="font-semibold text-pink-400 mb-2">Order & Logistics Details</h3>
                <textarea
                  className="w-full h-40 p-2 rounded-md mb-2 bg-gray-700 text-white"
                  placeholder="Order details..."
                />
                <textarea
                  className="w-full p-2 h-40 rounded-md mb-2 bg-gray-700 text-white"
                  placeholder="Other remarks..."
                />
                <textarea
                  className="w-full p-2 h-40 rounded-md bg-gray-700 text-white"
                  placeholder="Instructions..."
                />
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Chart */}
      <div className="bg-gray-900 rounded-xl p-4 shadow-md md:w-1/3 w-full mx-auto">
        <Bar data={chartData} options={chartOptions} />
      </div>
    </div>
  );
}
